import { z } from "zod";
import { AgencyIdSchema } from "../primitives/ids.js";
import { ImportDraftIdSchema } from "./import-draft.js";
export const ArreBatchIdSchema = z
    .string()
    .regex(/^arre_[a-zA-Z0-9_-]+$/)
    .brand();
export const ArreBatchItemIdSchema = z
    .string()
    .regex(/^aritm_[a-zA-Z0-9_-]+$/)
    .brand();
export const ArreBatchStatusSchema = z.enum(["PENDING", "PROCESSING", "COMPLETE", "FAILED"]);
export const ArreBatchItemStatusSchema = z.enum([
    "PENDING",
    "PROCESSING",
    "COMPLETE",
    "FAILED",
    "BLOCKED",
]);
/** ARRE opportunity labels — suggestion/evidence only; not guarantees. */
export const ArreOpportunityLabelSchema = z.enum([
    "QUICK_FIX",
    "FIX_KIT_CANDIDATE",
    "RELAUNCH_CANDIDATE",
    "PROOF_RELAUNCH_CANDIDATE",
    "OWNERSHIP_GAP",
    "IMPORT_RICH",
    "LEAD_PATH_WEAK",
]);
/** CSV/ARRE batch upload — urls array or raw CSV text (url column). */
export const CsvArreUploadRequestV1Schema = z
    .object({
    schemaId: z.literal("csvArre.uploadRequest.v1"),
    urls: z.array(z.string().min(1).max(2048)).min(1).max(50).optional(),
    csvText: z.string().min(1).max(512_000).optional(),
})
    .strict()
    .refine((value) => (value.urls?.length ?? 0) > 0 || (value.csvText?.length ?? 0) > 0, {
    message: "urls_or_csv_required",
});
export const CsvArreUploadAcceptedV1Schema = z
    .object({
    schemaId: z.literal("csvArre.uploadAccepted.v1"),
    batchId: ArreBatchIdSchema,
    status: z.literal("PENDING"),
    submittedCount: z.number().int().positive(),
})
    .strict();
export const ArreBatchItemViewV1Schema = z
    .object({
    itemId: ArreBatchItemIdSchema,
    submittedUrl: z.string().min(1),
    scannedUrl: z.string().url().optional(),
    status: ArreBatchItemStatusSchema,
    rank: z.number().int().positive().optional(),
    opportunityLabel: ArreOpportunityLabelSchema.optional(),
    suggestionCount: z.number().int().nonnegative().optional(),
    importDraftId: ImportDraftIdSchema.optional(),
    failureReason: z.string().min(1).optional(),
})
    .strict();
export const ArreBatchViewV1Schema = z
    .object({
    schemaId: z.literal("arreBatch.view.v1"),
    batchId: ArreBatchIdSchema,
    agencyId: AgencyIdSchema,
    status: ArreBatchStatusSchema,
    submittedCount: z.number().int().nonnegative(),
    completedCount: z.number().int().nonnegative(),
    items: z.array(ArreBatchItemViewV1Schema),
    createdAt: z.string().datetime(),
    completedAt: z.string().datetime().optional(),
    failureReason: z.string().min(1).optional(),
})
    .strict();
export const ArreBatchListV1Schema = z
    .object({
    schemaId: z.literal("arreBatch.list.v1"),
    batches: z.array(z
        .object({
        batchId: ArreBatchIdSchema,
        status: ArreBatchStatusSchema,
        submittedCount: z.number().int().nonnegative(),
        completedCount: z.number().int().nonnegative(),
        createdAt: z.string().datetime(),
    })
        .strict()),
})
    .strict();
//# sourceMappingURL=csv-arre.js.map